module.exports = __webpack_public_path__ + "static/img/10.0c91eeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/zh/10.png
// module id = OBaJ
// module chunks = 0